import React, { useMemo, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { F, CLSNAME, CABIN } from "../data/aircraft";
import { STATS } from "../data/stats";
import { seatsTxt } from "../lib/engine";
import { Picture, Price } from "../lib/icons";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import RequestModal from "../components/RequestModal";

export default function AircraftDetailPage() {
  const { slug } = useParams();
  const [req, setReq] = useState(false);
  const code = useMemo(() => Object.keys(F).find((k) => F[k].n.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "") === slug), [slug]);
  if (!code) return (<div className="sk"><Navbar /><div className="wrap block"><div className="empty"><b>Aircraft not found</b><Link to="/fleet">Back to fleet</Link></div></div><Footer /></div>);
  const f = F[code];
  const st = STATS[code] || { n: 0 };
  const feats = [f.tw ? "Twin engine" : f.eng && f.eng.startsWith("3") ? "Three engines" : "Single engine", f.pr ? "Pressurised cabin" : (f.k === "heli" ? "" : "Unpressurised"), f.hi ? "Strong at high altitude" : ""].filter(Boolean);
  return (
    <div className="sk">
      <Navbar onRequest={() => setReq(true)} />
      <main>
        <section className="block wrap">
          <p style={{ margin: "0 0 14px" }}><Link to="/fleet" style={{ color: "var(--muted)", fontWeight: 600 }}>{"\u2190"} Back to fleet</Link></p>
          <div className="hero2">
            <div className="pic" style={{ aspectRatio: "16/11" }}><Picture code={code} /></div>
            <div>
              <h2 style={{ fontFamily: "var(--display)", fontWeight: 500, fontSize: 32, margin: "0 0 4px" }}>{f.n}</h2>
              <p className="subt">{CLSNAME[f.c]} {"\u00b7"} {st.n} in India's charter fleet</p>
              <div className="specs">
                <div><span>Engines</span><b>{f.eng}</b></div>
                <div><span>Seats in India</span><b>{seatsTxt(code)}</b></div>
                <div><span>Range</span><b>{f.r.toLocaleString("en-IN")} nm {"\u00b7"} {Math.round(f.r * 1.852).toLocaleString("en-IN")} km</b></div>
                <div><span>Cruise speed</span><b>{f.s} kt {"\u00b7"} {Math.round(f.s * 1.852)} km/h</b></div>
                <div><span>Max altitude</span><b>{f.ceil.toLocaleString("en-IN")} ft</b></div>
                <div><span>Cabin</span><b>{CABIN[f.c]}</b></div>
                <div><span>Manufacturer</span><b>{f.mk}</b></div>
                <div><span>Relative cost</span><b style={{ letterSpacing: ".06em" }}><Price tier={f.t} /></b></div>
              </div>
            </div>
          </div>
          <p style={{ margin: "20px 0 0", fontSize: 16, maxWidth: "70ch" }}>{f.d}</p>
          {feats.length ? <div className="feat" style={{ marginTop: 14 }}>{feats.map((x) => <span key={x}>{x}</span>)}</div> : null}
          <div style={{ marginTop: 20 }}><button className="btn primary" type="button" onClick={() => setReq(true)}>Request this aircraft</button></div>
        </section>
      </main>
      <Footer />
      {req ? <RequestModal prefill={{ ac: code }} onClose={() => setReq(false)} /> : null}
    </div>
  );
}
